export default class Configuration {
    constructor(config) {
        this.config = config || {};
    }

    get CookieName() { return this.config.cookieName || "cookieConsent"; }

    get LegalNoticeLink() { return this.config.legalNotice || ""; }
    get GetDeniedPages() { return this.config.pagesNotToShow || []; }

    get LegalNoticeText() { return this.config.legalNoticeText || "Legal Notice"; }

    get HiddenClassName() { return this.config.hideClass || "hidden"; }

    get AcceptCallback() {
        if (typeof this.config.acceptCallback === "function") {
            return this.config.acceptCallback;
        }
        return function () {};
    }

    get DeclineCallback() {
        if (typeof this.config.declineCallback === "function") {
            return this.config.declineCallback;
        }
        return function () {};
    }

    get Categories() {
        if (this.config.categories) {
            return this.config.categories;
        }

        return [
            {
                name: "required",
                displayName: "Required",
                cookies: ["session", this.CookieName],
                description: "Cookies that required for site to work",
            },
        ];
    }

    get HideClass() {
        if (this.config.hideClass) {
            return this.config.hideClass;
        }
        return "hide";
    }

    get CookieSettingsHeader() {
        if (typeof this.config.cookieSettingsHeader !== "undefined") {
            return this.config.cookieSettingsHeader;
        }
        return "Cookie Settings";
    }

    get CookieSettingsDescription() {
        if (typeof this.config.cookieSettingsDescription !== "undefined") {
            return this.config.cookieSettingsDescription;
        }
        return "Here you can edit your cookie settings.";
    }


    get cookieSettingsConfirm() {
        if (this.config.cookieSettingsConfirm) {
            return this.config.cookieSettingsConfirm;
        }
        return "Accept settings";
    }

    get AllowAllCookiesText() {
        if (this.config.allowAllCookiesText) {
            return this.config.allowAllCookiesText;
        }
        return "Accept All";
    }

    get AllowRequiredCookiesText(){
        if (this.config.allowRequiredCookiesText) {
            return this.config.allowRequiredCookiesText;
        }
        return "Accept Required";
    }

    get OpenSettingsText() {
        if (this.config.openSettingsText) {
            return this.config.openSettingsText;
        }
        return "Open settings";
    }

    get ConsentDescription() {
        if (this.config.consentDescription) {
            return this.config.consentDescription;
        }
        return "General description about cookies";
    }

    get Domain() {
        if (this.config.domain) {
            return this.config.domain;
        }
        return window.location.hostname.replace(/^www\./, '');
    }
}
